import { useContext } from "react";
import { ListContext } from "contexts";

export default () => useContext(ListContext);
